import { render, staticRenderFns } from "./selectPatient.vue?vue&type=template&id=549da9ca&scoped=true"
import script from "./selectPatient.vue?vue&type=script&lang=js"
export * from "./selectPatient.vue?vue&type=script&lang=js"
import style0 from "./selectPatient.vue?vue&type=style&index=0&id=549da9ca&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549da9ca",
  null
  
)

export default component.exports